import { connect } from 'react-redux';
import CreateQuizPage from '../components/pages/CreateQuizPage/index';
import {ROUTES} from '../constants';


const mapStateToProps = ({createQuiz,recipeReducer,location}) => {
	return {
		createQuiz,
		recipeReducer,
		location
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onDiscard : ()=>{
			dispatch((dispatch, getState)=>{
				const {location} = getState();
				if(location.prev.type!==''){
					dispatch(({
						type:location.prev.type,
						payload : location.prev.payload
					}));
				}else{
					dispatch(({type:ROUTES.CREATE_QUIZ_SELECTED}));
				}
			});
			
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateQuizPage);